import React from 'react';
import { ControlledTextInput } from 'components/shared/form/ControlledTextInput';
import { ControlledSelectGroup } from 'components/shared/form/ControlledSelectGroup';
import ControlledSearchSelectGroup from 'components/shared/form/ControlledSearchSelectGroup';
import { ControlledTextAreaInput } from 'components/shared/form/ControlledTextAreaInput';
import { ControlledCheckbox } from 'components/shared/form/ControlledCheckbox';

export const ContractTextAreaInput = (props) => (
  <ControlledTextAreaInput namespace='contract' {...props} />
);
export const ContractTextInput = (props) => (
  <ControlledTextInput namespace='contract' {...props} />
);
export const ContractSelectGroup = (props) => (
  <ControlledSelectGroup namespace='contract' {...props} />
);
// PLA-1040: searchable (typeahead) variant, drop-in for ContractSelectGroup.
export const ContractSearchSelectGroup = (props) => (
  <ControlledSearchSelectGroup namespace='contract' {...props} />
);

export const ContractCheckbox = (props) => (
  <ControlledCheckbox namespace='contract' {...props} />
);
